module.exports = __webpack_public_path__ + "static/media/api-award-2022.70fa4968.jpg";